<form
  *ngIf="form"
  [formGroup]="form"
>
  <mat-form-field>
    <input
      type="email"
      matInput
      [placeholder]="placeholder + ' *'"
      formControlName="email"
      appFormControl
      (blur)="emitValue()"
      (keydown.enter)="submit()"
    >
  </mat-form-field>
</form>
